import { brandColors } from '@src/assets/colors/brandColors';
import { DxDiagnosisResultMaturityEnum } from '@src/enum/dxDiagnosisResultMaturityEnum.ts';

type LayerGraphProps = {
  currentLayer: DxDiagnosisResultMaturityEnum;
};

const LayerGraph = ({ currentLayer }: LayerGraphProps) => {
  type LayerItemProps = {
    title: string;
    description: string;
    descriptionPositionLeft: string;
    tooltipPositionTop: string;
    tooltipPositionLeft: string;
    layer: DxDiagnosisResultMaturityEnum;
    svgElement: JSX.Element;
  };
  const LayerItem = ({
    title,
    description,
    descriptionPositionLeft,
    tooltipPositionTop,
    tooltipPositionLeft,
    layer,
    svgElement,
  }: LayerItemProps) => {
    return (
      <div className='relative'>
        {/* グラフ */}
        {svgElement}
        {/* 吹き出し */}
        <div
          className={`border-primary-500 absolute top-1/2 flex w-[95%] min-w-[165px] -translate-y-1/2 flex-col items-center justify-center rounded-md border border-solid ${currentLayer === layer ? 'bg-primary-500' : 'bg-white'} pt-[29.5%] lg:min-w-[140px]`}
          style={{ left: descriptionPositionLeft }}
        >
          <p
            className={`absolute inset-x-0 top-[19%] m-auto text-center text-[clamp(8px,calc(100vw/1080*13),14px)] ${currentLayer === layer ? 'text-primary-50' : 'text-primary-500'} lg:top-[15%]`}
          >
            {title}
          </p>
          {/* クエスチョンマーク */}
          <button
            type='button'
            className='peer absolute inset-x-0 bottom-[11%] m-auto w-5 lg:bottom-[7%]'
          >
            <svg
              width='20'
              height='21'
              viewBox='0 0 20 21'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M10.0239 14.2024C10.2024 14.2024 10.3537 14.1408 10.478 14.0176C10.6023 13.8943 10.6645 13.7434 10.6645 13.5649C10.6645 13.3864 10.6028 13.2349 10.4795 13.1107C10.3562 12.9865 10.2053 12.9244 10.0269 12.9244C9.84841 12.9244 9.69703 12.986 9.57275 13.1092C9.44846 13.2325 9.38632 13.3834 9.38632 13.5618C9.38632 13.7404 9.44797 13.8918 9.57126 14.0161C9.69445 14.1403 9.84533 14.2024 10.0239 14.2024ZM10.0056 16.5C9.18022 16.5 8.40286 16.3438 7.67352 16.0315C6.94418 15.7192 6.30582 15.2895 5.75846 14.7424C5.2111 14.1952 4.78115 13.5574 4.46863 12.8288C4.15621 12.1003 4 11.3219 4 10.4936C4 9.66522 4.15615 8.88912 4.46846 8.16527C4.78077 7.44143 5.21049 6.80582 5.75764 6.25846C6.30478 5.7111 6.94264 5.28115 7.67121 4.96863C8.39967 4.65621 9.17808 4.5 10.0064 4.5C10.8348 4.5 11.6109 4.65615 12.3347 4.96846C13.0586 5.28077 13.6942 5.71049 14.2415 6.25764C14.7889 6.80478 15.2188 7.44132 15.5314 8.16725C15.8438 8.8933 16 9.66901 16 10.4944C16 11.3198 15.8438 12.0971 15.5315 12.8265C15.2192 13.5558 14.7895 14.1942 14.2424 14.7415C13.6952 15.2889 13.0587 15.7188 12.3327 16.0314C11.6067 16.3438 10.831 16.5 10.0056 16.5ZM10 15.6429C11.4286 15.6429 12.6429 15.1429 13.6429 14.1429C14.6429 13.1429 15.1429 11.9286 15.1429 10.5C15.1429 9.07143 14.6429 7.85714 13.6429 6.85714C12.6429 5.85714 11.4286 5.35714 10 5.35714C8.57143 5.35714 7.35714 5.85714 6.35714 6.85714C5.35714 7.85714 4.85714 9.07143 4.85714 10.5C4.85714 11.9286 5.35714 13.1429 6.35714 14.1429C7.35714 15.1429 8.57143 15.6429 10 15.6429ZM10.0405 7.67753C10.3482 7.67753 10.6145 7.7744 10.8393 7.96813C11.0643 8.16198 11.1768 8.40423 11.1768 8.69489C11.1768 8.93973 11.1085 9.15764 10.9719 9.34863C10.8354 9.53973 10.6758 9.7122 10.4932 9.86604C10.2538 10.0784 10.0404 10.3174 9.8528 10.5832C9.66522 10.849 9.5706 11.1437 9.56896 11.4674C9.56467 11.5875 9.60462 11.6826 9.68879 11.7527C9.77297 11.8229 9.8711 11.8579 9.98319 11.8579C10.1034 11.8579 10.2047 11.8239 10.2871 11.7559C10.3696 11.6879 10.423 11.5981 10.4475 11.4865C10.5025 11.249 10.6016 11.0397 10.7449 10.8588C10.8882 10.678 11.0434 10.506 11.2105 10.3429C11.4509 10.1086 11.6496 9.84775 11.8068 9.56027C11.964 9.27269 12.0426 8.96423 12.0426 8.63489C12.0426 8.11247 11.8478 7.67775 11.4581 7.33071C11.0685 6.98379 10.6021 6.81033 10.0592 6.81033C9.67148 6.81033 9.3094 6.89989 8.97291 7.07901C8.63654 7.25824 8.35967 7.51033 8.14231 7.83528C8.07308 7.93473 8.05473 8.04368 8.08725 8.16214C8.11967 8.28071 8.19412 8.36379 8.3106 8.41137C8.43093 8.46731 8.54901 8.47544 8.66484 8.43577C8.78066 8.39599 8.87742 8.33473 8.95511 8.25198C9.08874 8.08967 9.24769 7.95335 9.43198 7.84302C9.61626 7.73269 9.81912 7.67753 10.0405 7.67753Z'
                fill={`${currentLayer === layer ? brandColors['50'] : brandColors['500']}`}
              />
            </svg>
          </button>
          {/* ホバー時の説明 */}
          <div className='invisible opacity-0 transition-all peer-hover:visible peer-hover:opacity-100'>
            <div
              className='absolute z-20 w-[90%] rounded-md border border-solid border-gray-200 bg-white p-4 text-[clamp(7px,calc(100vw/1080*12),12px)]'
              style={{
                top: tooltipPositionTop,
                left: tooltipPositionLeft,
              }}
            >
              <p className='font-semibold'>{title}</p>
              <p className='mt-px'>{description}</p>
            </div>
          </div>
          {/* グラフと繋ぐ線 */}
          <div className='bg-primary-500 absolute inset-y-0 right-full m-auto h-px w-1/4'>
            <div
              className={`bg-primary-500 absolute inset-y-0 right-[calc(100%-5px)] my-auto ml-[-5px] size-[10px] rounded-full border border-solid border-white ${currentLayer === layer ? 'outline-primary-500 outline outline-1 outline-offset-0' : ''}`}
            ></div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className='flex h-full items-center p-[8%] xl:p-[20px] lg:p-[10px]'>
        <div className='flex aspect-[1/2] w-[48%] flex-col justify-center gap-px'>
          <div className='relative z-40'>
            <LayerItem
              title='DXチャレンジ層'
              description='新規事業など事業成長を目的とした活動にチャレンジしている企業'
              descriptionPositionLeft='41%'
              tooltipPositionTop='90%'
              tooltipPositionLeft='6%'
              layer={DxDiagnosisResultMaturityEnum.DX_CHALLENGE}
              svgElement={
                <svg
                  className='h-auto w-full'
                  width='213'
                  height='81'
                  viewBox='0 0 213 81'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    className={`${currentLayer === DxDiagnosisResultMaturityEnum.DX_CHALLENGE ? 'fill-primary-500' : 'fill-primary-50'}`}
                    d='M15.2385 4.35594C11.3028 -3.11661 0 -0.390136 0 8.09221V81H55L15.2385 4.35594Z'
                  />
                </svg>
              }
            />
          </div>
          <div className='relative z-30'>
            <LayerItem
              title='デジタライゼーション層'
              description='既存事業/業務の変革を目的とした活動を実践している企業'
              descriptionPositionLeft='63%'
              tooltipPositionTop='90%'
              tooltipPositionLeft='6%'
              layer={DxDiagnosisResultMaturityEnum.DIGITALIZATION}
              svgElement={
                <svg
                  className='h-auto w-full'
                  width='213'
                  height='105'
                  viewBox='0 0 213 105'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    className={`${currentLayer === DxDiagnosisResultMaturityEnum.DIGITALIZATION ? 'fill-primary-500' : 'fill-primary-50'}`}
                    d='M55 0H0V105H109L55 0Z'
                  />
                </svg>
              }
            />
          </div>
          <div className='relative z-20'>
            <LayerItem
              title='DXレディ層'
              description='DXを実践するために必要となる基本的なケイパビリティの準備を行っている企業'
              descriptionPositionLeft='89%'
              tooltipPositionTop='90%'
              tooltipPositionLeft='6%'
              layer={DxDiagnosisResultMaturityEnum.DX_READY}
              svgElement={
                <svg
                  className='h-auto w-full'
                  width='213'
                  height='110'
                  viewBox='0 0 213 110'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    className={`${currentLayer === DxDiagnosisResultMaturityEnum.DX_READY ? 'fill-primary-500' : 'fill-primary-50'}`}
                    d='M109 0H0V110H166L109 0Z'
                  />
                </svg>
              }
            />
          </div>
          <div className='relative z-10'>
            <LayerItem
              title='DX予備層'
              description='問題意識を持っているが、取組みに躊躇している企業'
              descriptionPositionLeft='115%'
              tooltipPositionTop='90%'
              tooltipPositionLeft='6%'
              layer={DxDiagnosisResultMaturityEnum.DX_PRELIMINARY}
              svgElement={
                <svg
                  className='h-auto w-full'
                  width='213'
                  height='100'
                  viewBox='0 0 213 100'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    className={`${currentLayer === DxDiagnosisResultMaturityEnum.DX_PRELIMINARY ? 'fill-primary-500' : 'fill-primary-50'}`}
                    d='M212.074 88.3C214.877 93.6 210.973 100 204.969 100H8.00658C3.60296 100 0 96.4 0 92V0H166L212.074 88.3Z'
                  />
                </svg>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LayerGraph;
